var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@fluentui/react-components';
var ErrorView = function (_a) {
    var title = _a.title, description = _a.description, button = _a.button, onButtonClick = _a.onButtonClick;
    return (_jsxs("div", __assign({ className: "max-w-2xl mx-auto mt-10 p-6 bg-white rounded-sm" }, { children: [_jsx("h3", __assign({ className: "text-2xl font-bold mb-4 text-error" }, { children: title })), _jsx("p", __assign({ className: "mb-4" }, { children: description })), _jsx("div", __assign({ className: "flex justify-center" }, { children: button && onButtonClick && _jsx(Button, __assign({ type: "button", className: "w-1/3 text-white primary-button", onClick: onButtonClick }, { children: button })) }))] })));
};
export default ErrorView;
